import axios from "axios";
import { getUserAuth } from "../helpers";
import {
  aesDecryptJSON,
  aesEncryptJSON,
  generateAesKey,
  normalizePemFromEnv,
  rsaDecryptToRawKey,
  rsaEncryptRawKey,
} from "./crypto";
import { SERVER_PRIVATE_KEY, SERVER_PUBLIC_KEY } from "./secureAxios";

export const API_BASE_URL = process.env["REACT_APP_SERVER_BASE_URL"];
export const SERVER_BASE_URL = process.env["REACT_APP_SERVER_URL"];
export const AUTOMATION_UPDATION_TOKEN= process.env["REACT_APP_AUTOMATION_UPDATION_TOKEN"] || "";
export const REACT_APP_THEME = process.env["REACT_APP_THEME"];

export const OTHER_USER_ACCESS_SUB_DOMAIN =
  process.env["REACT_APP_OTHER_USER_ACCESS_DOMAIN"];

export const CSIO_DEV_SERVER_URL = process.env["REACT_APP_CSIO_DEV_SERVER_URL"];

export const SECURE_API_ENABLED = false; //Boolean(process.env["REACT_APP_SECURE_API"]);


export const api = axios.create({
  baseURL: process.env["REACT_APP_SERVER_URL"],
});

export const csioDevApi = axios.create({
  baseURL:
    process.env["REACT_APP_CSIO_DEV_SERVER_URL"] ||
    process.env["REACT_APP_SERVER_URL"],
});

export const csioApi = axios.create({
  baseURL: process.env["REACT_APP_SERVER_URL_CSIO"],
});

export const sendGrigApi = axios.create({
  baseURL: process.env["REACT_APP_SEND_GRID"],
});
export const SKIP_PATHS_FOR_ENCRYPTION = [
  "/decrypt-payload",
  "/general/upload",
  "/general/download-files",

  "/policy/import-ifta-commauto-risk-profile-v2/preview",

  "/policy/get-policy-garage-insurance-certificate-pdf",
  "/policy/get-policy-commauto-liability-insurance-certificate-pdf",
  "/policy/get-policy-commauto-garage-insurance-certificate-pdf",
  "/policy/get-policy-commauto-liability-slip-certificate-pdf",
  "/policy/get-policy-commauto-opcf-seventeen-certificate-pdf",
  "/policy/get-policy-commauto-opcf-twenty-eight-a-certificate-pdf",
  "/policy/get-policy-commauto-sef-twenty-eight-a-certificate-pdf",
  "/policy/get-commauto-garage-application-pdf",
  "/policy/market-binder-preview-or-pdf",
  "/policy/business-claims-pdf",
  "/policy/get-policy-business-pre-authorization-form-pdf",
  "/policy/get-policy-liability-insurance-certificate-pdf",
  "/policy/get-policy-property-insurance-certificate-pdf",
  "/policy/get-habitational-binder-non-csio-pdf",
  "/policy/get-policy-habitational-liability-insurance-certificate-pdf",
  "/policy/get-habitational-payment-authorization-pdf",
  "/policy/habitational-claims-pdf",
  "/policy/get-policy-auto-paf-pdf",
  "/policy/get-policy-auto-liability-slip-certificate-pdf",
  "/policy/get-policy-auto-liability-insurance-certificate-pdf",
  "/policy/get-policy-auto-garage-insurance-certificate-pdf",
  "/policy/get-policy-auto-opcf-sixteen-certificate-pdf",
  "/policy/get-policy-auto-opcf-seventeen-certificate-pdf",
  "/policy/get-policy-auto-opcf-twenty-eight-a-certificate-pdf",
  "/policy/automobile-driver-claims-pdf",
  "/policy/get-policy-form-privacy-consent-form-pdf",
  "/policy/get-policy-form-ride-sharing-fillable-pdf",
  "/policy/get-policy-form-declaration-for-retiree-discount-pdf",
  "/policy/get-policy-form-rental-dwelling-declaration-pdf",
  "/policy/get-policy-form-rental-dwelling-pdf",
  "/policy/get-policy-form-garage-automobile-supplementary-form-pdf",
  "/policy/get-commauto-and-automobile-alberta-application-pdf",
  "/policy/get-commauto-and-automobile-application-pdf",
  "/policy/get-policy-commauto-risk-profile-market-submission-pdf",
  "/policy/get-telematics-form-pdf",
  "/policy/get-policy-opcf-forty-eight-certificate-pdf",
  "/policy/get-policy-opcf-forty-nine-certificate-pdf",
  "/policy/get-alberta-sef-sixteen-certificate-pdf",
  "/policy/get-alberta-sef-seventeen-certificate-pdf",
  "/policy/get-alberta-sef-nineteen-certificate-pdf",
  "/policy/get-alberta-sef-thirteen-d-certificate-pdf",
  "/policy/get-alberta-sef-thirteen-h-certificate-pdf",
  "/policy/get-alberta-sef-forty-certificate-pdf",
  "/policy/get-certificate-of-automobile-insurance-pdf",
  "/policy/get-cancellation-and-reinstatement-pdf",
  "/policy/get-policy-change-pdf",
  "/policy/get-intact-authorization-certificate-pdf",
  "/policy/get-all-customer-policy-renew-details-pdf",
  "/policy/auto-driver-and-habitational-claims-pdf",

  "/accounting/get-account-payment-accounts-receivable-pdf",
  "/accounting/preview-account-invoice-pdf",
  "/accounting/get-account-cheque-pdf",
  "/accounting/get-customer-statement-pdf",
  "/accounting/get-account-operating-statement-v2-pdf",
  "/accounting/get-balance-sheet-data-v2-pdf",
  "/accounting/get-account-position-report-pdf",
  "/accounting/get-aged-company-payable-pdf",
  "/accounting/get-remittance-list-by-insurance-company-pdf",
  "/accounting/get-account-cheque-report-pdf",
  "/accounting/get-bank-debit-credit-pdf",
  "/accounting/get-gl-invoice-entry-pdf",

  "/tasks/get-tasks-cancellation-and-reinstatement-pdf",

  "/docusign/get-documents",
  "/docusign/get-recipient",
  "/docusign/get-placeholder",
  "/docusign/insert-all-sign-trasition",
  "/docusign/insert-all-sign-transition",
  "/docusign/generate-signed-document",
  "/docusign/test-generate-sign-document",
  "/docusign/preview-document",
  "/docusign/get-audit-trail",
  "/docusign/mark-as-read-document",
  "/docusign/insert-sign",
  "/policy/get-habitational-binder-pdf",
  "/docusign/insert-all-sign",
  "/docusign/insert-all-trasition-sign",
  "/docusign/send-email-for-signature",
  "/general/merge-pdfs",
  "/docusign/insert-document",
  "/docusign/get-documents",

  "/docusign/insert-recipient",
  "/docusign/get-recipient",

  "/docusign/insert-placeholder",
  "/docusign/get-placeholder",

  "/docusign/send-email-for-signature",
  "/docusign/resend-sign-email-to-recipient",

  "/docusign/mark-as-read-document",

  "/docusign/insert-sign",
  "/docusign/insert-all-sign",
  "/docusign/insert-all-sign-transition",
  "/docusign/insert-all-trasition-sign",

  "/docusign/generate-signed-document",
  "/docusign/test-generate-sign-document",
  "/docusign/preview-document",
  "/docusign/get-audit-trail",

  "/accounting/edit-account-invoice"
];

let isAlert = false;

const logoutUser = () => {
  // Perform any necessary cleanup tasks, e.g., clearing local storage
  localStorage.clear();
  isAlert = true;
  // Redirect to the login page or perform any other required action
  window.alert(
    "Attention: Your session has expired. Please log in again to continue accessing the system. Thank you!"
  );
  window.location.href = "/auth/login"; // Replace with your desired logout destination
};

api.interceptors.request.use(async (config) => {
  const accessToken = getUserAuth();

  if (accessToken && config.headers) {
    config.headers["auth-Token"] = `${accessToken}`;
  }

  const data = config.data || {};

  if (
    config.url &&
    SKIP_PATHS_FOR_ENCRYPTION.some((url) => config.url!.includes(url))
  ) {
    return config;
  }

  if (SECURE_API_ENABLED && !(data instanceof FormData)) {
    try {
      const method = (config.method || "get").toLowerCase();

      const serverPubPem = normalizePemFromEnv(SERVER_PUBLIC_KEY || "");

      // Generate AES key
      const { raw: rawAesKey } = await generateAesKey();

      let payload: any = {};

      // ✅ Handle GET vs POST properly
      if (method === "get") {
        payload = config.params || {};
      } else {
        payload = config.data || {};
      }

      // Encrypt payload
      const { data: encryptedDataBase64, iv: ivBase64 } = await aesEncryptJSON(
        rawAesKey,
        payload
      );

      // Encrypt AES key with RSA
      const encryptedAesKeyBase64 = await rsaEncryptRawKey(
        serverPubPem,
        rawAesKey
      );

      //@ts-ignore
      config.headers["encryptedkey"] = encryptedAesKeyBase64;
      //@ts-ignore
      config.headers["iv"] = ivBase64;

      // ✅ Where to put encrypted payload?
      if (method === "get") {
        // Send encrypted data as query param for GET
        config.params = {
          data: encryptedDataBase64,
        };
      } else {
        // Send encrypted data as body for POST/PUT/PATCH etc.
        config.data = {
          data: encryptedDataBase64,
        };
      }

      return config;
    } catch (err) {
      console.error("Request encryption failed:", err);
      throw err;
    }
  }

  return config;
});

api.interceptors.response.use(
  async (response) => {
    if (!SECURE_API_ENABLED) {
      return response;
    }

    try {
      const resp = response.data;

      // Not encrypted → return as-is
      if (!resp?.encryptedKey || !resp?.iv || !resp?.data) {
        return response;
      }

      const clientPrivPem = normalizePemFromEnv(SERVER_PRIVATE_KEY);

      const rawAesKeyArrayBuffer = await rsaDecryptToRawKey(
        clientPrivPem,
        resp.encryptedKey
      );

      const decrypted = await aesDecryptJSON(
        rawAesKeyArrayBuffer,
        resp.data,
        resp.iv
      );

      return { ...response, data: decrypted };
    } catch (err) {
      console.error("Response decryption failed:", err);
      return Promise.reject(err);
    }
  },

  async (error) => {


    try {
      const resp = error?.response?.data;

      // If error response is encrypted → decrypt it
      if (resp?.encryptedKey && resp?.iv && resp?.data) {
        const clientPrivPem = normalizePemFromEnv(SERVER_PRIVATE_KEY);

        const rawAesKeyArrayBuffer = await rsaDecryptToRawKey(
          clientPrivPem,
          resp.encryptedKey
        );

        const decrypted = await aesDecryptJSON(
          rawAesKeyArrayBuffer,
          resp.data,
          resp.iv
        );

        // 🔑 Replace encrypted error data with decrypted payload
        error.response.data = decrypted;
      }
    } catch (decryptErr) {
      console.error("Error response decryption failed:", decryptErr);
    }

    // Existing logic
    if (error.response?.status === 401) {
      if (!isAlert) {
        logoutUser();
      }
    }

    return Promise.reject(error);
  }
);

csioDevApi.interceptors.request.use(async (config) => {
  const accessToken = getUserAuth();

  if (accessToken && config.headers) {
    config.headers["auth-Token"] = `${accessToken}`;
  }
  if (
    config.url &&
    SKIP_PATHS_FOR_ENCRYPTION.some((url) => config.url!.includes(url))
  ) {
    return config;
  }
  if (SECURE_API_ENABLED) {
    try {
      const method = (config.method || "get").toLowerCase();

      const serverPubPem = normalizePemFromEnv(SERVER_PUBLIC_KEY || "");

      // Generate AES key
      const { raw: rawAesKey } = await generateAesKey();

      let payload: any = {};

      // ✅ Handle GET vs POST properly
      if (method === "get") {
        payload = config.params || {};
      } else {
        payload = config.data || {};
      }

      // Encrypt payload
      const { data: encryptedDataBase64, iv: ivBase64 } = await aesEncryptJSON(
        rawAesKey,
        payload
      );

      // Encrypt AES key with RSA
      const encryptedAesKeyBase64 = await rsaEncryptRawKey(
        serverPubPem,
        rawAesKey
      );

      //@ts-ignore
      config.headers["encryptedkey"] = encryptedAesKeyBase64;
      //@ts-ignore
      config.headers["iv"] = ivBase64;

      // ✅ Where to put encrypted payload?
      if (method === "get") {
        // Send encrypted data as query param for GET
        config.params = {
          data: encryptedDataBase64,
        };
      } else {
        // Send encrypted data as body for POST/PUT/PATCH etc.
        config.data = {
          data: encryptedDataBase64,
        };
      }

      return config;
    } catch (err) {
      console.error("Request encryption failed:", err);
      throw err;
    }
  }
  return config;
});

csioDevApi.interceptors.response.use(
  async (response) => {
    if (!SECURE_API_ENABLED) {
      return response;
    }
    try {
      // if server returned an encrypted payload structure, decrypt it.
      const resp = response.data;
      if (!resp || !resp.encryptedKey || !resp.iv || !resp.data) {
        // Not an encrypted response - return as-is
        return response;
      }

      const clientPrivPem = normalizePemFromEnv(SERVER_PRIVATE_KEY);
      // rsaDecrypt -> raw AES key ArrayBuffer
      const rawAesKeyArrayBuffer = await rsaDecryptToRawKey(
        clientPrivPem,
        resp.encryptedKey
      );

      // aesDecrypt -> parsed JSON
      const decrypted = await aesDecryptJSON(
        rawAesKeyArrayBuffer,
        resp.data,
        resp.iv
      );

      // Return decrypted data to application code (like normal response)
      // Keep response structure similar to axios: attach decrypted data in response.data
      return { ...response, data: decrypted };
    } catch (err) {
      console.error("Response decryption failed:", err);
      // If decryption fails, surface error to app (or return raw response)
      // Here we reject to allow catching in app code
      return Promise.reject(err);
    }
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      if (!isAlert) {
        logoutUser();
      }
    }

    return Promise.reject(error);
  }
);
